module.exports = __webpack_public_path__ + "img/open.f33d85d1.png";